module.exports = __webpack_public_path__ + "assets/img/thumb-RSPCA-Pet-Insurance-Pillar-Page-Resource.6e6e77ed.webp";